import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocumentSquare2LeftLinesLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.6914 1.5C12.484 1.50004 13.9373 2.95357 13.9375 4.74609V11.2539C13.9373 13.0464 12.484 14.5 10.6914 14.5H5.30859C3.51614 14.4998 2.06267 13.0463 2.0625 11.2539V4.74609C2.06265 2.95364 3.51614 1.50015 5.30859 1.5H10.6914ZM5.30859 2.5C4.06842 2.50015 3.06265 3.50592 3.0625 4.74609V11.2539C3.06267 12.4941 4.06844 13.4998 5.30859 13.5H10.6914C11.9317 13.5 12.9373 12.4941 12.9375 11.2539V4.74609C12.9373 3.50585 11.9317 2.50004 10.6914 2.5H5.30859ZM10.2077 9.43685C10.4838 9.43686 10.7077 9.66072 10.7077 9.93685C10.7077 10.213 10.4838 10.4368 10.2077 10.4368H5.79427C5.51813 10.4368 5.29427 10.213 5.29427 9.93685C5.29429 9.66072 5.51814 9.43685 5.79427 9.43685H10.2077ZM7.86589 6.29688C8.14203 6.29688 8.36589 6.52073 8.36589 6.79688C8.36589 7.07302 8.14203 7.29688 7.86589 7.29688H5.79427C5.51813 7.29688 5.29427 7.07302 5.29427 6.79688C5.29427 6.52073 5.51813 6.29688 5.79427 6.29688H7.86589Z",
		fill: "currentColor"
	})
});
export default SvgDocumentSquare2LeftLinesLine;
